export const clampPercentage = (value) => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return 0;
    }

    return Math.min(100, Math.max(0, parsed));
};

export const calculateWeightedTotals = (items, { normalize = true } = {}) => {
    const totalWeight = items.reduce((sum, item) => sum + (Number(item.weight) || 0), 0);
    const earnedContribution = items.reduce((sum, item) => {
        const weight = Number(item.weight) || 0;
        const percent = clampPercentage(item.percent);
        return sum + (weight * percent) / 100;
    }, 0);

    if (totalWeight === 0) {
        return { totalWeight, earnedContribution, percentage: 0 };
    }

    const percentage = normalize ? (earnedContribution / totalWeight) * 100 : earnedContribution;

    return { totalWeight, earnedContribution, percentage };
};

export const calculateNeededToPass = ({
    targetPercent,
    earnedContribution,
    remainingWeight,
    totalWeight
}) => {
    const safeTarget = clampPercentage(targetPercent);

    if (!Number.isFinite(totalWeight) || totalWeight <= 0) {
        return {
            requiredPercent: null,
            isPossible: false,
            targetContribution: 0
        };
    }

    if (!Number.isFinite(remainingWeight) || remainingWeight <= 0) {
        return {
            requiredPercent: null,
            isPossible: false,
            targetContribution: (safeTarget / 100) * totalWeight
        };
    }

    const targetContribution = (safeTarget / 100) * totalWeight;
    const rawRequired = ((targetContribution - earnedContribution) / remainingWeight) * 100;

    return {
        requiredPercent: rawRequired,
        isPossible: rawRequired <= 100,
        targetContribution
    };
};
